// `window.features` is filled by a fetch kicked off at app boot (see index.jsx),
// so await `featuresReady` before reading it. Missing flag => disabled.
export async function isFeatureEnabled(name) {
    await window.featuresReady;
    return window.features?.includes(name) || false;
}
